import API from './api';

export const sendNotificationError = ({ message, details }) =>
  API.post('/log/appError', { message, details })
    .then(res => res)
    .catch(err => {
      throw err;
    });
